import { TASK_STATUS_KEYS } from "utils/taskService";

export const ALL_COLUMNS_VISIBLE = TASK_STATUS_KEYS.reduce(
  (acc, status) => ({ ...acc, [status]: true }),
  {}
);

const parseStatusFilter = (statusFilter) =>
  String(statusFilter ?? "")
    .split(",")
    .map((status) => status.trim().toUpperCase())
    .filter((status) => TASK_STATUS_KEYS.includes(status));

export const withFilteredStatusesVisible = (visibleColumns, statusFilter) => {
  const requested = parseStatusFilter(statusFilter);
  if (!requested.length) return visibleColumns;
  return requested.reduce(
    (acc, status) => (acc[status] ? acc : { ...acc, [status]: true }),
    visibleColumns
  );
};
